// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  myurl : 'http://3.110.134.254:4200',
  // myurl : 'http://localhost:4200',

  // api : 'https://localhost:3000', 
  api : 'https://3.110.134.254:3000',   

  CLIENT_ID : 'a53d6fba-e979-4e2a-be6f-a088a97e0974',
  OBJECT_ID : '83680540-128e-4325-bef7-abded68a5ddd',
  TENANT_ID : '2e8fb6cf-d6bc-4ed5-a29d-e9a26fbf8a0b',

  // REDIRECT_URI : 'https://localhost:3000/auth/callback',
  REDIRECT_URI : 'https://3.110.134.254:3000/auth/callback',
  
  CLIENT_SECRET : '7_J8Q~DbZpfWurwQpGJSyvTB1pnVio7.Uk59zcin',
  CLIENT_SECRET_ID : '503b07ac-6aa0-43fd-9a14-7f1cdad6b776',

  header_logo: 'assets/header/header-logo.png',
  header_logo_name: 'Assetto',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
